import styles from "./CatchyCheckbox.module.css";
export default function CatchyCheckbox({ label, type = 1, handleCheck, data }) {
  const isActive = data[label];
  // console.log(label, "-----------", isActive);
  return (
    <>
      {type == 1 ? (
        <div
          className={`${styles["inline-flex"]} items-center ${styles["gap-2"]}`}
          onClick={handleCheck}
        >
          <div
            className={`${styles["cursor-pointer"]} ${styles.checkbox} ${
              isActive ? styles.active : ""
            }`}
          ></div>
          <label>{label}</label>
        </div>
      ) : (
        <div
          className="w-full flex flex-col justify-center items-center"
          onClick={handleCheck}
        >
          <p className="text-justify w-full h-full text-xs flex justify-center px-2 p-2 border border-solid border-gray-400">
            {label}
          </p>
          <div className="w-full flex p-2 justify-center items-center border border-solid border-gray-400">
            <div
              className={`${styles["cursor-pointer"]} ${styles.checkbox} ${
                isActive ? styles.active : ""
              }`}
            ></div>
          </div>
        </div>
      )}
    </>
  );
}
